/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * A request to create a checkout session with Stripe.
 * @export
 * @interface StripeCheckoutSessionRequest
 */
export interface StripeCheckoutSessionRequest {
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof StripeCheckoutSessionRequest
     */
    amount: CurrencyAmount;
    /**
     * 
     * @type {string}
     * @memberof StripeCheckoutSessionRequest
     */
    description?: string;
    /**
     * The URL to redirect to after payment completion
     * @type {string}
     * @memberof StripeCheckoutSessionRequest
     */
    returnUrl?: string;
}

/**
 * Check if a given object implements the StripeCheckoutSessionRequest interface.
 */
export function instanceOfStripeCheckoutSessionRequest(value: object): value is StripeCheckoutSessionRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function StripeCheckoutSessionRequestFromJSON(json: any): StripeCheckoutSessionRequest {
    return StripeCheckoutSessionRequestFromJSONTyped(json, false);
}

export function StripeCheckoutSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeCheckoutSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': CurrencyAmountFromJSON(json['amount']),
        'description': json['description'] == null ? undefined : json['description'],
        'returnUrl': json['return_url'] == null ? undefined : json['return_url'],
    };
}

export function StripeCheckoutSessionRequestToJSON(json: any): StripeCheckoutSessionRequest {
    return StripeCheckoutSessionRequestToJSONTyped(json, false);
}

export function StripeCheckoutSessionRequestToJSONTyped(value?: StripeCheckoutSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': CurrencyAmountToJSON(value['amount']),
        'description': value['description'],
        'return_url': value['returnUrl'],
    };
}

